<template>
  <el-dialog v-dialogDrag :visible.sync="dialog" width="930px" :close-on-click-modal="false" :before-close="reset">
    <span slot="title" class="dialog-title">调控设置</span>
    <div>
      <el-form ref="reffromDate" :disabled="readOnly" :inline="true" :model="fromDate">
        <div class="title">结算办法：</div>
        <el-form-item prop="paymentMethodId" label="结算方式：">
          <el-select ref="paymentMethod" v-model="fromDate.paymentMethodId" placeholder="请选择" style="width: 100px"
            @change="
              $nextTick(() => {
                fromDate.paymentMethod = $refs.paymentMethod.selectedLabel;
              })
              ">
            <el-option label="双控" value="0"></el-option>
            <el-option label="图结" value="1"></el-option>
            <el-option label="实结" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="settlementCycle" label="结算周期：" style="float: none">
          <el-input v-model="fromDate.settlementCycle" type="Number" :oninput="settlementInput()" style="width: 200px"
            @focus.native="tooltipStatus = true" @blur.native="tooltipStatus = false">
            <template slot="prepend">每月</template>
            <template slot="append">号</template>
          </el-input>
          <!-- <el-tooltip v-model="tooltipStatus" effect="dark" placement="top-end">
            <div slot="content">填写[1]判断为自然月<br />填写[2-31]判断为指定日期</div>
          </el-tooltip> -->
          <el-tooltip effect="dark" placement="top-end">
            <div slot="content">填写[1]判断为自然月<br />填写[2-31]判断为指定日期</div>
            <i class="el-icon-warning-outline delete-icon"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item prop="checkTime" label="对账时限：">
          <el-input v-model="fromDate.checkTime" type="Number"
            oninput="if(value>999|| (value<1 && value !== ''))value=999" style="width: 200px">
            <template slot="append">天</template>
          </el-input>
        </el-form-item>
        <!-- class="title" -->
        <div>
          <el-form-item prop="daySettlement" label="总结算 结算周期:完工未办阶段开始">
            <el-input v-model="fromDate.daySettlement" type="Number"
              oninput="if(value>999|| (value<1 && value !== ''))value=999" style="width: 200px">
              <template slot="append">天</template>
            </el-input>
          </el-form-item>
        </div>
        <el-form-item prop="payTermId" label="付款办法：">
          <el-select ref="payTermId" v-model="fromDate.payTermId" placeholder="请选择" style="width: 150px" @change="
            $nextTick(() => {
              fromDate.payTermName = $refs.payTermId.selectedLabel;
            }),
            (fromDate.phaseList0 = [])
            ">
            <el-option v-for="(item, index) in payTermList" :key="index" :label="item.itemName"
              :value="item.itemValue"></el-option>
          </el-select>
        </el-form-item>
        <div>
          <div style="padding-bottom: 10px; display: flex;
  justify-content: flex-end">
            <el-button size="mini" class="bottom_all" style="margin-left: 0"
              @click="addItem(fromDate.payTermId != '2' ? phaseListPt : phaseListTs, 1)">
              <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
              添加
            </el-button>
          </div>
          <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
            style="width: 100%" :data="fromDate.payTermId != '2' ? phaseListPt : phaseListTs" tooltip-effect="dark">
            <el-table-column label="选择" width="50" align="center">
              <template slot-scope="scope">
                <el-radio v-model="engineeringPhaseId" :checked="engineeringPhaseId === scope.row.id" :label="scope.row"
                  @change="engineeringPhaseIdChange(scope.row)">{{ "" }}</el-radio>
              </template>
            </el-table-column>
            <el-table-column v-if="fromDate.payTermId != '2'" label="工程供应状态" align="center" prop="brand" width="auto">
              <template slot-scope="scope">
                <span v-if="scope.row.field2 === 'fixed'">{{ scope.row.supplyPhase }}</span>
                <el-input v-else v-model="scope.row.supplyPhase" :disabled="scope.row.monthSharding ? true : false"
                  style="width: 100%; text-align: center" :controls="false"></el-input>
              </template>
            </el-table-column>
            <el-table-column v-if="fromDate.payTermId != '2'" label="账期" align="center" width="auto">
              <template slot-scope="scope">
                <el-input v-model="scope.row.accountPeriod" :disabled="scope.row.monthSharding ? true : false"
                  type="Number" style="width: 100%">
                  <template slot="append">天</template>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column v-if="fromDate.payTermId != '2'" label="日期" align="center" prop="monthSharding">
              <!-- <template slot-scope="scope">
                {{scope.row.monthSharding.slice(0,3)}}年
              </template> -->
            </el-table-column>
            <el-table-column v-if="fromDate.payTermId == '2'" label="日期" align="center" prop="monthSharding">
              <template slot-scope="scope">
                <el-date-picker v-model="scope.row.monthSharding" type="month" placeholder="选择日期"
                  value-format="yyyy-MM-dd"> </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column label="应收比例" align="center">
              <template slot-scope="scope">
                <!-- <el-input-number v-model="scope.row.item" class="FZTcenter" style="width: 100%;" :min="1" :max="100" :controls="false">
                  <template slot="append">%</template>
                  </el-input-number> -->
                <el-input v-model="scope.row.item"
                  :disabled="fromDate.payTermId != '2' && (scope.row.monthSharding ? true : false)" class="FZTcenter"
                  style="width: 100%" type="Number" :min="1" :max="100" :controls="false">
                  <template slot="append">%</template>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column v-if="fromDate.payTermId != '2'" label="办理结算天数" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.paymentDays" :disabled="scope.row.monthSharding ? true : false" type="Number"
                  style="width: 100%; text-align: center" @change="itemFun(scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" prop="specification" width="90">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.supplyPhase != '在建' && scope.row.supplyPhase != '完工未办' && scope.row.supplyPhase != '完工已办'"
                  size="mini" class="bottom_two"
                  @click="delItem(fromDate.payTermId != '2' ? phaseListPt : phaseListTs, scope.$index)">
                  <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!--  <div class="title" style="padding-top: 10px;">付款办法：
          <el-button size="mini" class="bottom_all" style="margin-left: 0;" @click="addItem(fromDate.phaseList1, 2)">
              <i class="icon iconfont iconicon_button_add" style="font-size: 12px;"></i>
              添加
            </el-button>
        </div>
      
        <el-form-item prop="paymentDays" label="账期：">
          <el-input v-model="fromDate.paymentDays" type="Number">
            <template slot="append">天</template>
          </el-input>
        </el-form-item> -->
        <!-- <div>
          <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width:100%" :data="fromDate.phaseList1" tooltip-effect="dark" highlight-current-row @current-change="engineeringPhaseIdChange">
            <el-table-column label="选择" width="55">
              <template slot-scope="scope">
                <el-radio v-model="engineeringPhaseId" :checked="engineeringPhaseId === scope.row.id" :label="scope.row" @change="engineeringPhaseIdChange(scope.row)">{{""}}</el-radio>
              </template>
            </el-table-column>
            <el-table-column label="工程阶段" align="center" prop="brand" width="auto">
              <template slot-scope="scope">
                <el-input v-model="scope.row.supplyPhase" class="FZTcenter" style="width: 100%;"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="账期" align="center"  width="auto">
              <template slot-scope="scope">
                <el-input v-model="scope.row.paymentDays" type="Number" style="width:100%">
                <template slot="append">天</template>
              </el-input>
              </template>
            </el-table-column>
            <el-table-column label="日期" align="center" prop="monthSharding" width="auto"> -->
        <!-- <template slot-scope="scope">
               {{scope.row.monthSharding}}
              </template> -->
        <!-- </el-table-column>
            <el-table-column label="应收比例" align="center">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.item" class="FZTcenter" style="width: 100%;" :min="1" :max="100" :controls="false"><template slot="append">%</template></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="left" prop="specification" width="100">
              <template slot-scope="scope">
                <el-button size="mini" class="bottom_two" @click="delItem(fromDate.phaseList1, scope.$index)">
                  <i class="icon iconfont iconicon_button_delete" style="font-size: 12px;"></i>
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div> -->
        <el-form-item label="结清时限：" prop="settlementTimeLimit" style="margin-top: 10px">
          <el-date-picker v-model="fromDate.settlementTimeLimit" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"> </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="reset">取 消</el-button>
      <el-button v-if="!readOnly" class="bottom_all" style="margin-left: 24px" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryControl, saveControl, savePhase } from "@/api/internetSales/engineeringControl.js";
import { getDicType } from "@/api/common.js";
import { setTimeout } from "timers";
import { _debounce } from '@/utils/utils.js'
let loading = false;
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    low: {
      type: Object,
      default: new Object(),
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fromDate: {
        id: "",
        engineeringId: "",
        paymentMethod: "",
        paymentMethodId: "",
        settlementCycle: "",
        progressPaymentCycle: "",
        paymentDays: "",
        progressPaymentRatio: "",
        settlementTimeLimit: "",
        increasePaymentRatio: "",
        supplyPhase: "",
        supplyPhaseId: "",
        endStatementDay: "",
        phaseList: [],
        phaseList0: [],
        engineeringPhaseList: [],
        phaseList1: [],
        engineeringPhase: "",
        engineeringPhaseId: "",
        checkTime: "",
        //付款办法
        payTermId: "1",
        payTermName: "普通付款",
      },
      engineeringPhaseId: "",
      payTermList: [],
      tooltipStatus: false,
      phaseListPt: [], //普通付款表格
      phaseListTs: [], //特殊付款表格
    };
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.engineeringPhaseId = "";
        queryControl({ engineeringId: this.low.id })
          .then(res => {
            // for (let key in this.fromDate) {
            //   this.fromDate[key] = res.data[key];
            // }
            this.$set(this, 'fromDate', res.data)
            this.fromDate.phaseList0 = JSON.parse(JSON.stringify(this.fromDate.phaseList));
            this.fromDate.phaseList1 = JSON.parse(JSON.stringify(this.fromDate.engineeringPhaseList));
            this.phaseListPt = [];
            this.phaseListTs = [];
            if (!this.fromDate.payTermId) {
              this.fromDate.payTermId = "1";
            }
            if (this.fromDate.phaseList0.length == 0) {
              const data = [
                {
                  supplyPhase: "完工已办",
                  engineeringId: this.low.id,
                  item: "",
                  type: 1,
                  status: 1,
                  field2: "fixed",
                },
                {
                  supplyPhase: "完工未办",
                  engineeringId: this.low.id,
                  item: "",
                  type: 1,
                  status: 1,
                  field2: "fixed",
                },
                {
                  supplyPhase: "在建",
                  engineeringId: this.low.id,
                  item: "",
                  type: 1,
                  status: 1,
                  field2: "fixed",
                },
              ];
              this.phaseListPt = data;
            } else {
              if (this.fromDate.payTermId != "2") {
                this.phaseListPt = JSON.parse(JSON.stringify(this.fromDate.phaseList));
              } else {
                this.phaseListTs = JSON.parse(JSON.stringify(this.fromDate.phaseList));
              }
            }

            // this.fromDate.phaseList0.push({
            //   id: 2,
            //   supplyPhase: '供应完毕',
            //   item: this.fromDate.endStatementDay,
            // })
            setTimeout(() => {
              this.engineeringPhaseId = this.fromDate.engineeringPhaseList?.find(res => res.id == this.fromDate.engineeringPhaseId);
            }, 100);
          })
          .catch(() => {
            this.reset();
          });
      }
    },
  },
  mounted() {
    getDicType({ code: "payTerm" }).then(res => {
      this.payTermList = res.data.items;
    });
  },
  methods: {
    settlementInput() {
      let value = this.fromDate.settlementCycle
      if ((value || value === 0) && (value > 31 || value < 1)) { value = 31 }
      this.fromDate.settlementCycle = value
    },
    supplyDate(row) {
      // console.log(row.monthSharding.length,'日期202201')
      if (row.monthSharding) {
        if (row.monthSharding.length > 6) {
          return row.monthSharding.substr(0, 4) + row.monthSharding.substr(5, 2);
        } else if (row.monthSharding.length == 6) {
          return row.monthSharding.substr(0, 4) + row.monthSharding.substr(4, 2);
        }
      }
    },
    engineeringPhaseIdChange(val) {
      console.log(val);
      this.engineeringPhaseId = val;
      this.fromDate.engineeringPhase = val.supplyPhase;
      this.fromDate.engineeringPhaseId = val.id;
      console.log("工程阶段选择");
    },
    itemFun(row) {
      //供应完毕赋值
      if (row.id == 2) {
        this.fromDate.endStatementDay = row.item;
      }
    },
    reset() {
      this.$emit("reset", "dialog3");
    },
    submit: _debounce(function () {
      console.log(1);
      this.$refs.reffromDate.validate(valid => {
        if (valid) {
          // let arr = JSON.parse(JSON.stringify(curList))
          // let update = arr.filter((res) =>
          //   this.fromDate.phaseList.some((item) => res.id == item.id)
          // );
          // let deleteData = this.fromDate.phaseList.filter(
          //   (res) => !update.some((item) => res.id == item.id)
          // );
          // deleteData.forEach((res) => {
          //   res.status = 0; //0是删除
          // });
          // let addData = arr.filter(item=> {
          //   return !item.id
          // });

          if (this.fromDate.payTermId != "2") {
            this.fromDate.phaseList0 = this.phaseListPt;
          } else {
            this.fromDate.phaseList0 = this.phaseListTs;
          }
          let zjCount = 0;
          let wgybCount = 0;
          let wgwbCount = 0;
          this.fromDate.phaseList0.forEach(item => {
            if (item.supplyPhase == "在建") {
              zjCount++;
            }
            if (item.supplyPhase == "完工未办") {
              wgwbCount++;
            }
            if (item.supplyPhase == "完工已办") {
              wgybCount++;
            }
          });
          if (zjCount > 1 || wgybCount > 1 || wgwbCount > 1) {
            this.$message.warning("在建、完工未办、完工已办禁止重复!");
            return;
          }
          this.fromDate.phaseList = this.processData(this.fromDate.phaseList, this.fromDate.phaseList0);
          console.log(this.fromDate.phaseList);
          console.log(this.fromDate);
          saveControl(this.fromDate)
            .then(res => {
              if (res.code == 1001) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
              }
              this.$emit("submit", "dialog3");
            })
            .catch(() => {
            });
        } else {
          return false;
        }
      });
    }, 500),
    processData(oldList, curList) {
      let arr = JSON.parse(JSON.stringify(curList));
      let update = arr.filter(res => oldList.some(item => res.id == item.id));
      let deleteData = oldList.filter(res => !update.some(item => res.id == item.id));
      deleteData.forEach(res => {
        res.status = 0; //0是删除
      });
      let addData = arr.filter(item => {
        return !item.id;
      });

      return [...update, ...deleteData, ...addData];
    },
    addItem(list, type) {
      const data = {
        supplyPhase: "",
        engineeringId: this.low.id,
        item: "",
        type: type,
        status: 1,
      };
      list.splice(0, 0, data);
    },
    delItem(list, index) {
      list.splice(index, 1);
    },
    addItem2() {
      if (loading) {
        return;
      }
      loading = true;
      const data = {
        supplyPhase: "",
        engineeringId: this.low.id,
        item: 1,
        type: 2,
      };
      savePhase(data)
        .then(res => {
          this.fromDate.engineeringPhaseList.push(res.data[res.data.length - 1]);
          loading = false;
        })
        .catch(() => {
          loading = false;
        });
    },
    delItem2(row, index) {
      if (loading) {
        return;
      }
      loading = true;
      savePhase({ id: row.id, status: 0, engineeringId: row.engineeringId, type: 2 })
        .then(() => {
          this.fromDate.engineeringPhaseList.splice(index, 1);
          loading = false;
        })
        .catch(() => {
          loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  font-weight: bold;
  font-size: 18px;
  padding-bottom: 18px;
}

.el-input,
.el-select {
  width: 240px;
}
</style>


